import axios from 'axios';
import { getLocalYYYYMMDD } from '../../../_mexablock/helpers';
const API_URL = process.env.REACT_APP_API;

// ---------- helpers ----------
const buildQuery = (params: Record<string, any>) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.append(k, String(v));
  });
  const q = qs.toString();
  return q ? `?${q}` : '';
};
const date = getLocalYYYYMMDD();

const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, 0);
};

// ---------- 1) JSON: /reports/account-balance ----------
export async function getAccountBalanceReport(filters: {
  company_id?: number | string;
  start_date?: string; // YYYY-MM-DD
  end_date?: string; // YYYY-MM-DD
}) {
  const query = buildQuery({
    company_id: filters.company_id,
    start_date: filters.start_date,
    end_date: filters.end_date,
  });

  const res = await axios.get(`${API_URL}reports/account-balance${query}`);
  return res.data?.doc?.data; // ajusta si tu API responde distinto
}

// ---------- 2) PDF: /reports/account-balance/document/pdf ----------
export async function downloadAccountBalancePDF(filters: {
  company_id?: number | string;
  start_date?: string;
  end_date?: string;
}) {
  const query = buildQuery({
    company_id: filters.company_id,
    start_date: filters.start_date,
    end_date: filters.end_date,
  });

  try {
    const res = await axios.get(
      `${API_URL}reports/account-balance/document/pdf${query}`,
      { responseType: 'blob' },
    );

    const blob = new Blob([res.data], { type: 'application/pdf' });
    downloadBlob(blob, `REPORTE-ESTADO-DE-CUENTA-${date}.pdf`);
    return { ok: true };
  } catch (error: any) {
    // si tu backend manda error en JSON dentro de blob:
    if (error?.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        return JSON.parse(text);
      } catch {
        return { ok: false, message: text };
      }
    }
    return { ok: false, message: error?.message || 'Error al descargar PDF' };
  }
}

// ---------- 3) EXCEL: /reports/account-balance/document/excel ----------
export async function downloadAccountBalanceExcel(filters: {
  company_id?: number | string;
  start_date?: string;
  end_date?: string;
}) {
  const query = buildQuery({
    company_id: filters.company_id,
    start_date: filters.start_date,
    end_date: filters.end_date,
  });

  try {
    const res = await axios.get(
      `${API_URL}reports/account-balance/document/excel${query}`,
      { responseType: 'blob' },
    );

    // MIME típico para xlsx (si tu backend manda otro, no pasa nada)
    const blob = new Blob([res.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    downloadBlob(blob, `REPORTE-ESTADO-DE-CUENTA-${date}.xlsx`);
    return { ok: true };
  } catch (error: any) {
    if (error?.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        return JSON.parse(text);
      } catch {
        return { ok: false, message: text };
      }
    }
    return { ok: false, message: error?.message || 'Error al descargar Excel' };
  }
}

export async function parseAxiosError(error: any): Promise<string> {
  if (!error.response) {
    return 'No hay conexión a internet';
  }

  try {
    const raw = await error.response.data.text?.();
    const data = JSON.parse(raw || '{}');

    if (data.message?.includes('ETIMEDOUT')) {
      return 'No hay conexión a internet';
    }

    return data.message || 'Error desconocido del servidor';
  } catch {
    return 'Error inesperado al interpretar la respuesta del servidor';
  }
}

export async function getAllRol() {
  const response = await axios.get(`${API_URL}reports/roles/`);
  return response.data.doc.data;
}

export async function getAllSelectRol() {
  const data = await getAllRol();
  return data.map((row: any) => {
    const label = (row?.name ?? '').trim() || 'Sin nombre';

    return {
      ...row,
      value: row.code,
      label,
    };
  });
}

export async function getAllUsers(code_role: string) {
  const response = await axios.get(`${API_URL}reports/roles/users`, {
    params: { code_role: code_role?.trim() },
  });

  return response.data?.doc?.data ?? [];
}
